import { render, staticRenderFns } from "./PrescriptionHospital.vue?vue&type=template&id=41d3dcc8&"
import script from "./PrescriptionHospital.vue?vue&type=script&lang=js&"
export * from "./PrescriptionHospital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports